import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import AuthService from "../AuthService";

const authservice = new AuthService();

const profile = authservice.getProfile();
const moeda = profile?.empresa?.moeda || "REAL";

const utils = {
  optionsCurrency(style = "currency") {
    const optionsMap = {
      REAL: { currencySymbol: "R$", decimalPlaces: 2 },
      IENE: { currencySymbol: "￥", decimalPlaces: 0 },
    };

    const selected = optionsMap[moeda] || optionsMap["REAL"];
    return {
      ...selected,
      currencySymbol: style === "percent" ? "%" : selected.currencySymbol,
    };
  },

  formatNumber(value, style = "currency") {
    if (value === null || value === undefined) return value;

    const config = {
      REAL: {
        locales: "pt-BR",
        options: {
          style,
          currency: "BRL",
          useGrouping: true,
          maximumFractionDigits: 2,
        },
      },
      IENE: {
        locales: "ja-JP",
        options: {
          style,
          currency: "JPY",
          useGrouping: true,
          maximumFractionDigits: 0,
        },
      },
    };

    const { locales, options } = config[moeda] || config["REAL"];
    return new Intl.NumberFormat(locales, options).format(value);
  },

  setValue(objDest, name, value) {
    const keys = name.split(".");
    let ref = objDest;

    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        ref[key] = value;
      } else {
        if (!ref[key]) ref[key] = {};
        ref = ref[key];
      }
    });
  },

  getTotalItensPedido(pedido) {
    return pedido.itens.reduce((total, item) => {
      let subTotal = item.valorTotal || 0;
      if (item.subItens) {
        subTotal += item.subItens.reduce(
          (acc, sub) => acc + (sub.valorTotal || 0),
          0
        );
      }
      return total + subTotal;
    }, 0);
  },

  getTotalPedido(pedido) {
    let total = this.getTotalItensPedido(pedido);

    if (pedido.tipoDelivery === "ENTREGAR" && pedido.valorTaxaEntrega) {
      total += pedido.valorTaxaEntrega;
    }

    if (pedido.valorDesconto > 0) {
      total -= pedido.valorDesconto;
    }

    return total;
  },

  replaceValor(value) {
    return value?.toString().replace(",", ".") ?? "";
  },

  formataMonetario(value) {
    if (value === null || value === undefined) return "0,00";
    return parseFloat(value).toFixed(2).replace(".", ",");
  },

  formatarDataHora(data, timezone = "-03:00") {
    if (!data) return "";
    try {
      const date = utcToZonedTime(data, timezone);
      return format(date, "dd/MM/yy HH:mm");
    } catch (e) {
      console.error("Erro ao formatar data/hora:", data, e);
      return "";
    }
  },

  formatarData(data, timezone = "-03:00") {
    if (!data) return "";
    try {
      const date = utcToZonedTime(data, timezone);
      return format(date, "dd/MM/yyyy");
    } catch (e) {
      console.error("Erro ao formatar data:", data, e);
      return "";
    }
  },

  labelTipoIdentificador(tipo) {
    const labels = {
      MESA: "Mesa",
      COMANDA: "Comanda",
      DELIVERY: "Delivery",
      SEQUENCIAL: "Sequencial",
    };
    return labels[tipo] || "Outros";
  },

  onlyDigits(str) {
    return str?.replace(/\D/g, "") ?? "";
  },

  isDev() {
    return process.env.NODE_ENV === "development";
  },
};

export const createUUID = () => {
  let dt = new Date().getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const converterURLImagemProduto = (imagem) => {
  return imagem?.url && imagem?.publicId ? imagem.url + imagem.publicId : "";
};

export const formatTextToFirstLetterUpperCase = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (match) => match?.toUpperCase());
};
export default utils;
